import styled from "styled-components";

export const Main = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    left: 0;
    position: fixed;
    top: 0;
    z-index: 90;
`;


export const Overlay = styled.div`
    cursor: pointer;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background: rgba(0, 0, 0, 0.34);
    top: 0;
    left: 0;
    z-index: 1;
`

export const Content = styled.div`
    height: 60vh;
    width: 80vw;
    background: white;
    z-index: 200;
`;

export const Header = styled.div`
    padding: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.14);
    padding-bottom: 4px;
    margin: 0 8px;
    display: flex;
    justify-content: space-between;

    & .title{
        font-size: 18px;
        font-weight: 700;
        margin: 0;
    }

    & .btn-close{
        border: none;
        background: none;
        cursor: pointer;
    }
    & .btn-close:focus{
        outline: 0;
    }
`;


export const Body = styled.div`
    padding: 1rem;
    max-height: 90%;
    overflow-y: scroll;
`;